$('.product-customization-options-btns ul li button').click(function(){
   var tabid = $(this).attr('data-tab'); 
   $(tabid).show();
   $('.mobile-tab').not(tabid).hide();
  $('.product-customization-options-btns ul li button').not(this).removeClass('active');
  $(this).addClass('active');
});

$('.productcustomization-btn').click(function () {
  $('.product-customizerr-wrap').show();
  $('.mobile-product-customization-btn-wrap').hide();
  $('.product-options__option.dropdown').hide();
  $('.main-product__block-title').hide();
  $('.main-product__block-price').hide();
});

$('.product-customization-save-btn').click(function () {
  $('.product-customizerr-wrap').hide();
  $('.mobile-product-customization-btn-wrap').show();
   $('.product-options__option.dropdown').show();
    $('.main-product__block-title').show();
  $('.main-product__block-price').show();
});


$(document).on('click','.menu-body .menu ul li span',function(){
  //alert("click");
  //$('.menu-body .menu ul li').removeClass("open");
  $(this).parent().toggleClass("open");
  
});

$(document).on('click','.mem-switch img',function(){
  //alert("click");
  //$('.menu-body .menu ul li').removeClass("open");
  $('.lanej-side-menu').toggleClass("active");
  
});


$(document).on('click','.lanej-side-menu .menu-close',function(){
  //alert("click");
  //$('.menu-body .menu ul li').removeClass("open");
  $('.lanej-side-menu').removeClass("active");
  
});

